// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__NMGtk","rotate":"Spinner_rotate__99sdq","whiteSpinner":"Spinner_whiteSpinner__yCyrI"};